import { useFrame } from "@react-three/fiber"
import { useMemo, useRef } from "react"
import type { Group } from "three"
import type { LandingData } from "../data/types"
import { scenePresence, sectionFocus, type LandingMotionRef } from "../lib/landing-motion"
import { applyGroupOpacity } from "../lib/three"
import { signalColor } from "../lib/signal"
import { SceneText } from "./SceneText"

export function TickerStream({ data, motion }: { data: LandingData; motion: LandingMotionRef }) {
  const group = useRef<Group>(null)
  const labels = useMemo(() => data.lattice.filter((x) => x.symbol !== "-").slice(0, 32), [data])

  useFrame((_, delta) => {
    const section = motion.current.section
    const presence = scenePresence(section, 0.18, 1.92, 0.44)
    const focus = sectionFocus(section, 1, 0.8)
    if (!group.current) return
    group.current.rotation.y += delta * (0.035 + focus * 0.05)
    group.current.rotation.x = -0.04 + focus * 0.08
    group.current.position.set(-0.45 + focus * 0.22, -0.05, 0.5 - section * 0.58)
    group.current.scale.setScalar(0.92 + focus * 0.14)
    applyGroupOpacity(group.current, presence)
  })

  return (
    <group ref={group}>
      {labels.map((tile, i) => {
        const lane = i % 7
        const x = -4.2 + lane * 1.4
        const y = 2 - (i % 5) * 0.9
        const z = -2.2 + Math.floor(i / 7) * 0.72
        return (
          <SceneText
            key={`${tile.symbol}-${i}`}
            position={[x, y, z]}
            fontSize={i % 5 === 0 ? 0.34 : 0.2}
            color={signalColor(tile.sig)}
            fillOpacity={0.28}
            outlineWidth={0.004}
            outlineColor="#020404"
          >
            {tile.symbol}
          </SceneText>
        )
      })}
    </group>
  )
}
